<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="position-relative" style="min-width: 220px; max-width: 300px; flex: 1 1 auto;">
        <input
          v-model="searchQuery"
          type="text"
          class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
          placeholder="Rechercher..."
        />
      </div>
      <div class="d-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#bulkConfigModal"
          
          @click="initBulkField"
          v-if="current_permissions('create_config')"
        >
          {{ $t('configurations.addBulkConfig') || 'Ajout en masse' }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>

        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
          v-if="current_permissions('create_config')"
        >
          {{ $t('configurations.addConfig') }}
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('configurations.config') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('configurations.category') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('configurations.value') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(configuration, idx) in paginatedConfigurations" :key="configuration.code ?? (configuration.key + '-' + configuration.type + '-' + idx)">
              <td>{{ configuration.key }}</td>
              <td>{{ configuration.type }}</td>
              <td>
                <button
                  v-if="configuration.valeur !== null"
                  class="btn btn-none border-0 p-0"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#viewValueModal"
                  @click="showValue(configuration.key, configuration.valeur)"
                  :title="$t('configurations.viewValue') || 'Voir la valeur'"
                >
                  <i class="flaticon-eye"></i>
                </button>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button
                  class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                  type="button"
                  disabled
                  style="opacity: 0.35; cursor: not-allowed;"
                  :title="$t('configurations.comingSoon') || 'Bientôt disponible'"
                >
                  <i class="flaticon-dots"></i>
                </button>
                <!--
                <div class="dropdown">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li v-if="current_permissions('edit_config')">
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#companyModal" @click="showConfiguration(configuration.code)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span>{{ $t('configurations.edit') }}</span>
                      </a>
                    </li>
                    <li v-if="current_permissions('delete_config')">
                      <a class="dropdown-item d-flex align-items-center" style="color: red;" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#filterLeadModal" @click="showScreen(configuration.code)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        <span>Supprimer</span>
                      </a>
                    </li>
                  </ul>
                </div>
                -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination côté client, calculée sur la liste filtrée par la recherche -->
      <div v-if="total>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="total>itemsPerPage" class="mb-0 text-paragraph">
          {{ $t('configurations.showing') }} <span class="fw-bold">{{ Math.min(page*itemsPerPage, total) }}</span> {{ $t('configurations.outOf') }}
          <span class="fw-bold">{{ total }}</span> {{ $t('configurations.results') }}
        </p>
        <p v-if="total<=itemsPerPage" class="mb-0 text-paragraph">
          {{ $t('configurations.showing') }} <span class="fw-bold">{{ total }}</span> {{ $t('configurations.outOf') }}
          <span class="fw-bold">{{ total }}</span> {{ $t('configurations.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="setPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage}}</a>
              <a v-else class="page-link" @click="setPage(numPage)">{{ numPage}}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="setPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Delete Confirmation -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('configurations.alert') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancel()"></button>
        </div>
        <div class="modal-body">
          <div style="">
            <h6 v-if="errors==''" class="text-red fw-bold mb-0 text-center" style="color: red;">{{ $t('configurations.confirmDelete') }}</h6>
          </div>
          <div v-if="errors!==''">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn default-outline-btn bg-transparent" style="background-color: #FFF;" data-bs-dismiss="modal" @click="cancel()">
            {{ $t('configurations.no') }}
          </button>
          <button :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="deleteConfiguration()">
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('configurations.yes') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="viewValueModal" tabindex="-1" aria-labelledby="viewValueModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="viewValueModalLabel">{{ selectedValueKey }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.value') }}</label>
          <div class="row form-control shadow-none d-flex flex-row align-items-start mx-0 py-10">
            <textarea
              class="col fw-medium text-black fs-md-14 border-0"
              id="viewValueInput"
              v-model="selectedValueToShow"
              readonly
              rows="4"
              style="resize: vertical; background: transparent; overflow-y: auto; max-height: 260px; word-break: break-all; font-family: 'Courier New', monospace;"
            ></textarea>
            <div class="col-auto ps-0 pt-2">
              <a href="#" class="text-decoration-none d-block text-center" @click.prevent="copyValueToClipboard" :title="$t('configurations.copy') || 'Copier'">
                <i class="flaticon-draft fs-6" style="color: #000"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn text-white" style="background-color: #EB9355;" @click="copyValueToClipboard">
            <i class="flaticon-draft fs-6 me-5" style="color: #FFF;"></i>
            {{ $t('configurations.copy') || 'Copier' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('configurations.addConfig') : $t('configurations.editConfig') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.configName') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('configurations.configNamePlaceholder')" v-model="formValues.key" :class="{ 'is-invalid': errorsBis['key'] }" id="key" @blur="validate('key')" />
                    <span class="invalid-feedback">{{ errorsBis['key']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.value') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('configurations.valuePlaceholder')" v-model="formValues.val" :class="{ 'is-invalid': errorsBis['val'] }" id="val" @blur="validate('val')" />
                    <span class="invalid-feedback">{{ errorsBis['val']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.description') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('configurations.descriptionPlaceholder')" v-model="formValues.description" :class="{ 'is-invalid': errorsBis['description'] }" id="description" @blur="validate('description')" />
                    <span class="invalid-feedback">{{ errorsBis['description']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.category') }}</label>
                  <select name="mode" id="mode" class="form-select fs-md-15 text-black shadow-none" @change="handleCategorieChange" required>
                    <option value="" :selected="selectedCategorie==''">{{ $t('configurations.select') }}</option>
                    <option value="PROVIDER" :selected="selectedCategorie=='PROVIDER'">PROVIDER</option>
                    <option value="SYMFONY" :selected="selectedCategorie=='SYMFONY'">SYMFONY</option>
                    <option value="APP" :selected="selectedCategorie=='APP'">APP</option>
                    <option value="BROKER" :selected="selectedCategorie=='BROKER'">BROKER</option>
                  </select>
                </div>
                <div class="col-md-6" v-if="showSelectProvider">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.provider') }}</label>
                  <select name="provider" id="provider" class="form-select fs-md-15 text-black shadow-none" @change="handleProviderChange" required>
                    <option value="">{{ $t('configurations.select') }}</option>
                    <option v-for="provider in providers" :value="provider.code" :key="provider.code" :selected="selectedProvider==provider.code"> {{ provider.name }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;" v-if="current_permissions('create_config', 'edit_config')">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ edit == 0 ? $t('configurations.save') : $t('configurations.edit') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade" id="bulkConfigModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="submitBulk">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ $t('configurations.addBulkConfig') || 'Ajout en masse' }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="bulkErrors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ bulkErrorId }}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ bulkErrors }}</h6>
            </div>
            <div v-if="bulkSuccess!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ bulkSuccess }}</h6>
            </div>

            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.configName') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('configurations.configNamePlaceholder')" v-model="formValuesBulk.key" :class="{ 'is-invalid': errorsBisBulk['key'] }" id="keyBulk" @blur="validateBulkField('key')" />
                    <span class="invalid-feedback">{{ errorsBisBulk['key']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.value') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('configurations.valuePlaceholder')" v-model="formValuesBulk.val" :class="{ 'is-invalid': errorsBisBulk['val'] }" id="valBulk" @blur="validateBulkField('val')" />
                    <span class="invalid-feedback">{{ errorsBisBulk['val']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.description') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('configurations.descriptionPlaceholder')" v-model="formValuesBulk.description" :class="{ 'is-invalid': errorsBisBulk['description'] }" id="descriptionBulk" @blur="validateBulkField('description')" />
                    <span class="invalid-feedback">{{ errorsBisBulk['description']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.category') }}</label>
                  <select name="modeBulk" id="modeBulk" class="form-select fs-md-15 text-black shadow-none" @change="handleCategorieChangeBulk" required>
                    <option value="" :selected="selectedCategorieBulk==''">{{ $t('configurations.select') }}</option>
                    <option value="PROVIDER" :selected="selectedCategorieBulk=='PROVIDER'">PROVIDER</option>
                    <option value="SYMFONY" :selected="selectedCategorieBulk=='SYMFONY'">SYMFONY</option>
                    <option value="APP" :selected="selectedCategorieBulk=='APP'">APP</option>
                    <option value="BROKER" :selected="selectedCategorieBulk=='BROKER'">BROKER</option>
                  </select>
                </div>
                <div class="col-md-6" v-if="showSelectProviderBulk">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('configurations.provider') }}</label>
                  <select name="providerBulk" id="providerBulk" class="form-select fs-md-15 text-black shadow-none" @change="handleProviderChangeBulk" required>
                    <option value="">{{ $t('configurations.select') }}</option>
                    <option v-for="provider in providers" :value="provider.code" :key="provider.code" :selected="selectedProviderBulk==provider.code"> {{ provider.name }}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Liste des configurations déjà ajoutées, affichée sous le formulaire -->
            <div v-if="pendingConfigs.length>0" class="mt-20">
              <label class="d-block text-black fw-semibold mb-10">
                {{ $t('configurations.pendingList') || 'Configurations à créer' }} ({{ pendingConfigs.length }})
              </label>
              <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                  <thead>
                    <tr>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">{{ $t('configurations.config') }}</th>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">{{ $t('configurations.category') }}</th>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">{{ $t('configurations.value') }}</th>
                      <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, i) in pendingConfigs" :key="i">
                      <td>{{ item.key }}</td>
                      <td>{{ item.category }}</td>
                      <td style="max-width: 220px; overflow: hidden; text-overflow: ellipsis;">{{ item.value }}</td>
                      <td class="text-end pe-0">
                        <a href="javascript:void(0);" @click="removeFromPendingList(i)" :title="$t('configurations.remove') || 'Retirer'">
                          <i class="flaticon-delete" style="color: red;"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between align-items-center">
            <button
              type="button"
              class="btn text-white"
              style="background-color: #336e92;"
              @click="addToPendingList"
            >
              <i class="flaticon-plus position-relative me-5 fs-12" style="color: #FFF;"></i>
              {{ $t('configurations.addToList') || 'Ajouter à la liste' }}
            </button>

            <!-- Bouton Enregistrer (à droite) -->
            <button
              type="submit"
              class="btn text-white"
              style="background-color: #EB9355;"
              :disabled="!bulkBtnLoad || pendingConfigs.length===0"
              v-if="current_permissions('create_config')"
            >
              <span v-if="!bulkBtnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              {{ $t('configurations.save') }} ({{ pendingConfigs.length }})
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup  lang="ts">
import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import router from '../../router/index'
import * as yup from 'yup';
import { Configuration, ConfigurationByCategory, Provider } from "@/utils/Model";
import { useI18n } from "vue-i18n";
import { current_permissions } from '../../utils/permission';
import { showToast, checkSessionValidate } from "@/utils/function";

const backApi = inject('back');
const btnLoad = ref(true);
const { t } = useI18n();
const selectedValidation = ref('N');
const selected = ref(false);

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

const allConfigurations = ref(new Array<ConfigurationByCategory & { code?: string | null }>());

const searchQuery = ref('');

let edit = 0;
let itemCode = '';
let selectedOrganization = '';
const providers = ref(new Array<Provider>());

const selectedProvider = ref(null);

const selectedValueKey = ref('');
const selectedValueToShow = ref('');

const showValue = (key: string, valeur: any) => {
  selectedValueKey.value = key;
  selectedValueToShow.value = valeur !== null && valeur !== undefined ? String(valeur) : '';
}

const copyValueToClipboard = () => {
  const el = document.getElementById('viewValueInput') as HTMLTextAreaElement | null;
  if (!el) return;
  el.select();
  el.setSelectionRange(0, 99999);
  navigator.clipboard.writeText(el.value);
  showToast("Copié", "green");
}

let data = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'key': '', 'description': '', val: '', category: '' };
const pageLoad = ref(false);

const formValues = reactive({
  key: "",
  val: "",
  description: "",
  category: ""
});

const schema = yup.object({
  key: yup.string().required('Le nom est requis'),
  description: yup.string().required('La description est requise'),
  val: yup.string().required('La description est requise'),
});

function handleValidationChange(event) {
  selectedValidation.value = event.target.value;
}

function handleProviderChange(event) {
  selectedProvider.value = event.target.value;
}

const initField = () => {
  formValues.key = '';
  formValues.val = '';
  formValues.description = '';
  formValues.category = '';
  edit = 0;
}

let showSelectProvider = ref(false)
const selectedCategorie = ref('');
function handleCategorieChange(event) {
  selectedCategorie.value = event.target.value;

  if (selectedCategorie.value == 'PROVIDER') {
    showSelectProvider.value = true
  } else {
    selectedProvider.value = null
    showSelectProvider.value = false
  }
}

const formValuesBulk = reactive({
  key: "",
  val: "",
  description: ""
});

const errorsBisBulk = reactive({ 'key': '', 'description': '', val: '' });

const selectedCategorieBulk = ref('');
const selectedProviderBulk = ref(null);
const showSelectProviderBulk = ref(false);

const bulkBtnLoad = ref(true);
const bulkErrors = ref('');
const bulkErrorId = ref('');
const bulkSuccess = ref('');

// liste des configurations en attente d'envoi, affichée sous le formulaire
const pendingConfigs = ref(new Array<{ key: string; value: string; description: string; category: string; status: string }>());

// réinitialise tout l'état du modal d'ajout en masse à l'ouverture
const initBulkField = () => {
  formValuesBulk.key = '';
  formValuesBulk.val = '';
  formValuesBulk.description = '';
  errorsBisBulk.key = '';
  errorsBisBulk.description = '';
  errorsBisBulk.val = '';
  selectedCategorieBulk.value = '';
  selectedProviderBulk.value = null;
  showSelectProviderBulk.value = false;
  pendingConfigs.value = [];
  bulkErrors.value = '';
  bulkErrorId.value = '';
  bulkSuccess.value = '';
}

function handleCategorieChangeBulk(event) {
  selectedCategorieBulk.value = event.target.value;

  if (selectedCategorieBulk.value == 'PROVIDER') {
    showSelectProviderBulk.value = true
  } else {
    selectedProviderBulk.value = null
    showSelectProviderBulk.value = false
  }
}

function handleProviderChangeBulk(event) {
  selectedProviderBulk.value = event.target.value;
}

function validateBulkField(field) {
  schema
    .validateAt(field, { key: formValuesBulk.key, val: formValuesBulk.val, description: formValuesBulk.description })
    .then(() => {
      errorsBisBulk[field] = "";
    })
    .catch(err => {
      errorsBisBulk[field] = err.message;
    });
  bulkErrors.value = ''
}

const addToPendingList = () => {
  try {
    schema.validateSync(
      { key: formValuesBulk.key, val: formValuesBulk.val, description: formValuesBulk.description },
      { abortEarly: false }
    );
  } catch (error: any) {
    errorsBisBulk.key = '';
    errorsBisBulk.description = '';
    errorsBisBulk.val = '';
    if (error.inner && error.inner.length) {
      error.inner.forEach((e: any) => {
        errorsBisBulk[e.path] = e.message;
      });
    }
    return;
  }

  if (!selectedCategorieBulk.value) {
    showToast("Veuillez sélectionner une catégorie", "red");
    return;
  }

  // Nouveau contrôle : entreprise obligatoire si catégorie = PROVIDER
  if (selectedCategorieBulk.value === 'PROVIDER' && !selectedProviderBulk.value) {
    showToast("Veuillez sélectionner une entreprise (provider)", "red");
    return;
  }

  pendingConfigs.value.push({
    key: formValuesBulk.key,
    value: formValuesBulk.val,
    description: formValuesBulk.description,
    category: selectedCategorieBulk.value,
    status: 'ACTIVE'
  });

  formValuesBulk.key = '';
  formValuesBulk.val = '';
  formValuesBulk.description = '';
  errorsBisBulk.key = '';
  errorsBisBulk.description = '';
  errorsBisBulk.val = '';
}
const removeFromPendingList = (index: number) => {
  pendingConfigs.value.splice(index, 1);
}

const submitBulk = () => {
  if (pendingConfigs.value.length === 0) {
    showToast("Ajoutez au moins une configuration à la liste", "red");
    return;
  }

  bulkBtnLoad.value = false;
  bulkErrors.value = '';
  bulkErrorId.value = '';

  axios.post(`${backApi}/secure/configs/all`, {
    provider: selectedProviderBulk.value,
    organization: null,
    configs: pendingConfigs.value
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }).then((response) => {
    bulkBtnLoad.value = true;
    showToast("Enregistrement effectué avec succès", "green");
    setTimeout(() => {
      router.go();
    }, 500);
  }).catch((error) => {
    bulkBtnLoad.value = true;
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      } else {
        bulkErrorId.value = error.response.data.errorId;
        bulkErrors.value = error.response.data.message;
      }
      showToast(error.response.data.message, "red");
    }
  });
}

function flattenConfiguration(obj: any, path: string[] = []): Array<any> {
  const result: any[] = [];

  Object.entries(obj || {}).forEach(([key, value]) => {
    const isLeafWithCode =
      value !== null &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      'code' in (value as any) &&
      'value' in (value as any);

    const isPlainObjectToRecurse =
      value !== null &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      !isLeafWithCode;

    if (isPlainObjectToRecurse) {
      result.push(...flattenConfiguration(value, [...path, key]));
    } else if (isLeafWithCode) {
      const v: any = value;
      result.push({
        code: v.code ?? null,
        key: key,
        valeur: v.value,
        type: path.join(" >> ")
      });
    } else {
      result.push({
        code: null,
        key: key,
        valeur: value,
        type: path.join(" >> ")
      });
    }
  });

  return result;
}

const filteredConfigurations = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allConfigurations.value;

  return allConfigurations.value.filter((c) => {
    const key = (c.key ?? '').toString().toLowerCase();
    const type = (c.type ?? '').toString().toLowerCase();
    const valeur = (c.valeur ?? '').toString().toLowerCase();
    return key.includes(q) || type.includes(q) || valeur.includes(q);
  });
});

const page = ref(1);
const itemsPerPage = 10;
const total = computed(() => filteredConfigurations.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(total.value / itemsPerPage)));
const paginatedConfigurations = computed(() => {
  const start = (page.value - 1) * itemsPerPage;
  return filteredConfigurations.value.slice(start, start + itemsPerPage);
});
const setPage = (numPage: number) => {
  page.value = numPage;
};

watch(searchQuery, () => {
  page.value = 1;
});

const getConfigurations = () => {
  axios.get(backApi + '/secure/configs/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      data = response.data;
      allConfigurations.value = flattenConfiguration(response.data);
      page.value = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const showConfiguration = (code) => {
  if (!code) {
    showToast("Impossible d'identifier cet élément de configuration (aucun code disponible)", "red");
    return;
  }
  axios.get(backApi + '/secure/configs/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.key = response.data.key;
      formValues.val = response.data.value;
      formValues.description = response.data.description;
      formValues.category = response.data.category;
      selectedCategorie.value = response.data.category;
      itemCode = response.data.code;
      edit = 1;
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          console.log(error.response);
        }
      }
    });
}

// Récupère une page de providers depuis l'API (forme { data, pagination })
const fetchProvidersPage = (targetPage: number) => {
  const url = `${backApi}/secure/providers/?page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

// Charge TOUTES les pages de providers (boucle sur pagination.numPages)
const getProviders = async () => {
  try {
    const first = await fetchProvidersPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchProvidersPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    providers.value = collected;
    data = collected;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const showScreen = (code) => {
  if (!code) {
    showToast("Impossible d'identifier cet élément de configuration (aucun code disponible)", "red");
    return;
  }
  itemCode = code;
}

const cancel = () => {
  itemCode = "";
  errorId.value = "";
  errors.value = "";
}

const save = () => {
  if (edit == 0) {
    storeConfiguration()
  } else {
    updateConfiguration()
  }
}

const storeConfiguration = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);

    axios.post(`${backApi}/secure/configs/new`, {
      provider: selectedProvider.value,
      organization: null,
      key: formValues.key,
      value: formValues.val,
      description: formValues.description,
      category: selectedCategorie.value
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      showToast("Enregistrement effectué avec succès", "green");
      setTimeout(() => {
        router.go();
      }, 500);
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
        showToast(error.response.data.message, "red");
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const updateConfiguration = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/configs/${itemCode}/edit`, {
      key: formValues.key,
      value: formValues.val,
      description: formValues.description,
      category: selectedCategorie.value,
      code: itemCode,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        router.go();
      }
    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

const deleteConfiguration = () => {
  btnLoad.value = false;
  try {
    const headers = {
      'Authorization': `Bearer ${token}`
    }
    const data = {
      code: itemCode
    }
    axios.delete(`${backApi}/secure/configs/delete`, { headers, data })
      .then(response => {
        btnLoad.value = true;
        if (response.status === 200) {
          router.go();
        }
      })
      .catch(error => {
        btnLoad.value = true;
        if (error.response) {
          if (error.response.status === 401) {
            router.push('/')
          } else {
            errorId.value = error.response.data.errorId;
            errors.value = error.response.data.message;
          }
        }
      });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
    btnLoad.value = true;
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const exportExcel = () => {
  import("../../utils/Export2Excel").then((excel) => {
    const Header = ["CODE RECHARGEMENT", "DESCRIPTION", "MONTANT", "DATE", "STATUT"];
    const Fields = ["code", "description", "amount", "createdAt", "status"];
    const dataForExcel = formatJSon(Fields, data);
    excel.export_json_to_excel({
      header: Header,
      data: dataForExcel,
      sheetName: "Feuil1",
      filename: "rechargement",
      autoWidth: true,
      bookType: "xlsx",
    });
  });
}

function formatJSon(FilterData, JsonData) {
  return JsonData.map((v) => FilterData.map(j => {
    return v[j];
  }));
}

onMounted(async () => {
  checkSessionValidate(1);
  await getProviders();
  getConfigurations();

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});
</script>